module.exports = __webpack_public_path__ + "img/proscarpe.ee48bb19.png";